import styled from "styled-components";

export const MemberCard = styled.div`
  border: 1px solid #000000;
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const MemberContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

export const MemberInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MemberName = styled.h3`
  font-size: 18px;
  margin: 0;
  font-weight: bold;
`;

export const MemberTypeLabel = styled.p`
  font-size: 14px;
  margin: 0;
`;

export const MembershipInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
`;

export const MembershipLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.4;
`;

export const PriceLabel = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: #000;
`;

export const MembershipStatus = styled.span<{
  $status: "active" | "pending" | "companion";
}>`
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  color: ${(props) => {
    switch (props.$status) {
      case "active":
        return "#2E7D32";
      case "pending":
        return "#B45309";
      case "companion":
        return "#2E7D32";
      default:
        return "#F44336";
    }
  }};
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const ActionButton = styled.button<{
  $variant?: "black" | "orange" | "red" | "green";
}>`
  background-color: ${(props) => {
    switch (props.$variant) {
      case "orange":
        return "#FF9800";
      case "red":
        return "#F44336";
      case "green":
        return "#4CAF50";
      case "black":
      default:
        return "#000000";
    }
  }};
  color: white;
  padding: 12px;
  border: none;
  width: 100%;
  font-weight: bold;
  cursor: pointer;
  border-radius: 0 0 8px 8px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
